import { render, staticRenderFns } from "./EvaluationQuestions.vue?vue&type=template&id=642eb6e6&"
import script from "./EvaluationQuestions.vue?vue&type=script&lang=js&"
export * from "./EvaluationQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports